/**
 * Simple metric card for displaying single metrics (This Week, Today, etc.)
 */

import { Card, CardContent, CardHeader } from "@/components/ui/card";

export interface MetricCardProps {
  label: string;
  value: string | number;
  description?: string;
  testId?: string;
}

export function MetricCard({
  label,
  value,
  description,
  testId,
}: MetricCardProps) {
  return (
    <Card data-testid={testId}>
      <CardHeader className="p-4 border-b">
        <h2 className="font-semibold">{label}</h2>
      </CardHeader>
      <CardContent className="p-4">
        <div className="text-center">
          <div className="text-3xl font-bold">{value}</div>
          {description && (
            <div className="text-xs text-muted-foreground mt-1">{description}</div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}

